import { Injectable } from '@angular/core';
import { Socket } from "ngx-socket-io";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class SocketService {

  constructor(private socket: Socket) {
    if(environment.enable_chat) {
      this.socket.on('deal_fulfilled', (data: any) => {
        console.log("----->>>>>>>", data);
      });
    }
  }

  onCreateRoom(configData: any) {
    if(!environment.enable_chat) return;
    if(!this.socket.ioSocket.connected) this.socket.connect();
    this.socket.emit('store_id', configData);
  }
  
}